<template>
  <b-modal
    :id="modalId"
    title="Assign status to board"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    @shown="onModalShown"
    modal-class="assign-status-modal"
  >
    <div class="select-status-modal">
      <p class="mb-2">
        This column doesn't have a default status assigned. Please select the status you want to assign to 
        <strong>{{ jobTitle }}</strong>:
      </p>
      
      <div class="form-group mb-2">
        <label for="status-select" class="form-label">Status:</label>
        <v-select
          id="status-select"
          v-model="selectedStatus"
          :options="availableStatuses"
          :value="selectedStatusId"
          code="id"
          label="displayName"
          placeholder="Choose a status..."
          ref="statusSelect"
        />
      </div>

      <div class="form-group mb-2">
        <b-form-checkbox
          v-model="autoAssignFuture"
          class="auto-assign-checkbox"
        >
          Automatically assign future jobs that move to this board with this status
        </b-form-checkbox>
      </div>
      
      <div v-if="validationError" class="alert alert-danger mt-2">
        {{ validationError }}
      </div>
    </div>

    <template #modal-footer="{ cancel }">
      <b-button variant="primary" @click="confirmSelection" :disabled="!selectedStatus">
        Confirm
      </b-button>
      <b-button variant="outline-secondary" @click="cancel()">
        Cancel
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: 'SelectStatusModal',
  components: {
    'v-select': vSelect
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    availableStatuses: {
      type: Array,
      required: true
    },
    targetColumnId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedStatus: null,
      autoAssignFuture: true, // Default to checked
      validationError: null
    };
  },
  computed: {
    jobTitle() {
      return this.job ? this.job.id : 'this job';
    },
    selectedStatusId() {
      return this.selectedStatus ? this.selectedStatus.id : null;
    }
  },
  methods: {
    onModalShown() {
      // Focus the status select when modal is shown
      this.$nextTick(() => {
        if (this.$refs.statusSelect) {
          this.$refs.statusSelect.focus();
        }
      });
    },
    
    confirmSelection() {
      this.validationError = null;
      
      if (!this.selectedStatus) {
        this.validationError = 'Please select a status.';
        return;
      }
      
      // Emit the selection event with the selected status and auto-assign preference
      this.$emit('status-selected', {
        statusId: this.selectedStatus.id,
        statusName: this.selectedStatus.displayName,
        job: this.job,
        targetColumnId: this.targetColumnId,
        autoAssignFuture: this.autoAssignFuture
      });
      
      // Hide the modal
      this.$bvModal.hide(this.modalId);
      
      // Reset form
      this.resetForm();
    },
    
    resetForm() {
      this.selectedStatus = null;
      this.autoAssignFuture = true; // Reset to checked by default
      this.validationError = null;
    }
  },
  
  watch: {
    // Reset form when modal is hidden
    '$bvModal.show': function(show) {
      if (!show) {
        this.resetForm();
      }
    }
  }
};
</script>

<style scoped>
.select-status-modal {
  min-height: auto;
}

.form-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.alert {
  font-size: 0.875rem;
}

.auto-assign-checkbox {
  font-size: 0.9rem;
}

.auto-assign-checkbox >>> .custom-control-label {
  padding-left: 0.25rem;
  line-height: 1.4;
}
</style>

<style>
/* Global styles for this modal */
.assign-status-modal .modal-dialog {
  max-width: 450px !important;
  width: 450px !important;
}

.assign-status-modal .modal-header {
  background-color: #6c757d;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1rem; /* Reduce header padding */
}

.assign-status-modal .modal-body {
  padding: 1rem; /* Reduce body padding */
}

.assign-status-modal .modal-footer {
  padding: 0.75rem 1rem; /* Reduce footer padding */
}

.assign-status-modal .modal-title {
  color: white !important;
  font-weight: 600;
}
</style>
